/* eslint-disable array-callback-return */
import React, { useEffect, useState, useCallback } from "react";
import DashboardPage from "../../layout";
import { b2bReportList, syncB2BOrderOnSAP } from "../../api/employee";
import { getGlobalFilter } from "../../api/filters";
import PaginationComponent from "../../components/Pagination";
import Loader from "../../components/Loader";
import Export from "../../assets/icons/Export.svg";
import Filter from "../../assets/icons/Filter.svg";
import {
    formatCurrentStartDate,
    formatCurrentEndDate,
    getPagePerSize,
    formatNumberWithoutFraction
} from "../../utility";
import TimeFrameSelector from "../../components/TimeFrameSelector";
import { formatDate } from "../../utility";
import Dropdown from "../../components/Dropdown";
import { useDateRangeSelector } from "../../components/DateRangeSelector";
import DropdownMulti from "../../components/DropdownMultiple";
import moment from "moment";
import { useTranslation } from "react-i18next";
import Close from "../../assets/close-circle.svg";
import Search from "../../assets/Search.svg";
import { useNavigate } from "react-router-dom";
import URL_MAPPING from "../../routes/constants";
import { formatNumber, TimeZoneDisplay } from "../../utility";
import Button from "../../components/Button";
import debounce from "lodash/debounce";
import { toast, ToastContainer } from "react-toastify";
import Eye from "../../assets/eye.svg";
import ImageDailog from "../../components/ImageDailog";
import SyncIcon from "../../assets/refresh.svg";

const B2BReport: React.FC = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [searchQuery, setSearchQuery] = useState("");
    const [open, setOpen] = useState(false);
    const [employees, setEmployeesData] = useState<any>([]);
    const [loading, setLoading] = useState(false);
    const [loadingFilter, setLoadingForFilter] = useState(false);
    const [timeFrame, setSelectTimeFrame] = useState<any>("Today");
    const [startDate, setStartDate] = useState<any>(new Date());
    const [endDate, setEndDate] = useState<any>(new Date());
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [sortType, setSortType] = useState<any>("");
    const { t } = useTranslation();
    const statusOptions = [
        { value: "CONFIRMED", label: "Confirmed" },
        { value: "PENDING_SAP", label: "Pending to Sync" },
        { value: "DELIVERED", label: "Delivered" },
        { value: "CANCELLED", label: "Cancelled" }, 
    ];
    const orderTypeOptions = [
        { value: "ALL", label: "All" },
        { value: "CREDIT", label: "Credit" },
        { value: "PAID", label: "Paid" },
    ];
    const [globalFilters, setGlobalFilters] = useState<any>(null);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [selectedEmpId, setSelectedEmpId] = useState<any>([]);
    const [selectedEmpStatus, setSelectedEmpStauts] = useState<string[]>([]);
    const [selectedOrderType, setSelectedOrderType] = useState<string[]>([]);
    const [selectedSalesOffice, setSelectedSalesOffice] = useState<any>([]);
    const [selectedRegion, setRegion] = useState<any>([]);
    const [territoryId, setTerritoryId] = useState<any>([]);
    const [routeId, setRouteId] = useState<any>([]);
    const [userType, setUserType] = useState<any>("");
    const [channelId, setChannelId] = useState<any>([]);
    const [dateMode, setDateMode] = useState<"picker" | "month">("picker");
    const dateRangeSelector = useDateRangeSelector(2024);
    const startIndex = (currentPage - 1) * employees?.size;
    const navigate = useNavigate();
    const employeesPerPage = getPagePerSize();
    const [viewImg, setViewImg] = useState<any>(false);
    const [imgUrl, setImgUrl] = useState<any>();
    const [imgType, setImgType] = useState<any>();
    const [syncingOrderId, setSyncingOrderId] = useState<string | number | null>(null);

    const getGlobalFilters = async (data: any) => {
        try {
            setLoadingForFilter(true);
            const response = await getGlobalFilter(data);
            setLoadingForFilter(false);
            setGlobalFilters(response);
        } catch (error) {
            console.error("Error fetching global filters:", error);
        }
    };

    const handleFilterClick = () => {
        setOpen(true);
    };

    const handleChange = (event: any) => {
        updateSearchTerm(event);
        setSearchQuery(event);
    };

    const updateSearchTerm = useCallback(
        debounce((value: string) => {
            const data: any = {
                start_date: formatCurrentStartDate(new Date(startDate)),
                end_date: formatCurrentEndDate(new Date(endDate)),
            };

            if (value) {
                data["search"] = value;
            }
            getPayload(data);
            const params = {
                page: 1,
                size: employeesPerPage,
            };
            setCurrentPage(1);
            getEmployeesData(data, params);
        }, 500),
        [
            startDate,
            endDate,
            selectedEmpStatus,
            selectedOrderType,
            channelId,
            selectedRegion,
            routeId,
            selectedSalesOffice,
            selectedEmpId,
            territoryId,
            userType,
            sortType,
            employeesPerPage,
        ]
    );

    const handleSortFillter = (data: string) => {
        if (data === sortType) {
            setSortType("");
            handleApply("");
        } else {
            setSortType(data);
            handleApply(data);
        }

        setIsDropdownOpen(false);
    };

    function getCurrentDate() {
        const date = new Date();
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    }

    const handleClose = () => setOpen(false);

    const handleClearFilters = () => {
        setSelectedEmpId([]);
        setSelectedSalesOffice([]);
        setRegion([]);
        setTerritoryId([]);
        setRouteId([]);
        setUserType(null);
        setChannelId([]);
        setSelectedEmpStauts([]);
        setSelectedOrderType([]);
        dateRangeSelector.reset();
        setDateMode("picker");
        setStartDate(getCurrentDate());
        setEndDate(getCurrentDate());
        setSelectTimeFrame("Today");
        setOpen(false);
        handleClearApply("");
    };

    const handleClearApply = (sort: string) => {
        const data: any = {
            start_date: formatCurrentStartDate(new Date()),
            end_date: formatCurrentEndDate(new Date()),
        };
        const params = {
            page: 1,
            size: employeesPerPage,
        };
        data["positions"] =[]

        setCurrentPage(1);
        getEmployeesData(data, params);
        handleClose();
    };

    const handleExport = async () => {
        setLoading(true);
        const data: any = {
            start_date: formatCurrentStartDate(new Date(startDate)),
            end_date: formatCurrentEndDate(new Date(endDate)),
            export: true,
            time_zone: TimeZoneDisplay(),
        };

        if (searchQuery) {
            data["search"] = searchQuery;
        }
        if (sortType) {
            data["sort_by"] = sortType;
        }
        getPayload(data);
        const params = {};
        try {
            await exportActiviyData(data, params);
        } catch (error) {
            console.error("Error exporting data:", error);
        } finally {
            setLoading(false);
        }
    };

    const exportActiviyData = async (data: any, params: any) => {
        await b2bReportList(params, data)
            .then((res) => {
                toast.success(res?.message)
                // const url = window.URL.createObjectURL(new Blob([res]));
                // const a = document.createElement("a");
                // a.href = url;
                // a.download = `team_activity_report.csv`;
                // a.click();
                // a.remove();
                // window.URL.revokeObjectURL(url);
            })
            .catch((error) => {
                console.error("Error fetching Employee data:", error);
                toast.warn(error?.response?.data?.detail)
            });
    };

    const getEmployeesData = async (data: any, params: any) => {
        setLoading(true);
        await b2bReportList(params, data)
            .then((res) => {
                setEmployeesData(res);
                setLoading(false);
            })
            .catch((error) => {
                console.error("Error fetching Employee data:", error);
                setLoading(false);
            });

    };

    const handleStartDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setStartDate(e.target.value);
        checkTimeFrame(e.target.value, endDate);
    };

    const handleEndDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setEndDate(e.target.value);
        checkTimeFrame(startDate, e.target.value);
    };

    const applyYearMonth = (yearVal: number, monthVal: number) => {
        if (!yearVal || !monthVal) return;
        const { start, end } = dateRangeSelector.getMonthRange(yearVal, monthVal);
        setStartDate(formatDate(start));
        setEndDate(formatDate(end));
        setDateMode("month");
    };

    const handleMonthYearDropdownChange = (value: string | number) => {
        const yearNum = Number(value);
        dateRangeSelector.setSelectedMonthYear(yearNum);
        if (dateRangeSelector.selectedMonth) {
            const monthNum = Number(dateRangeSelector.selectedMonth);
            if (yearNum === dateRangeSelector.currentYear && monthNum > dateRangeSelector.currentMonth) {
                dateRangeSelector.setSelectedMonth("");
            } else {
                applyYearMonth(yearNum, monthNum);
            }
        }
    };

    const handleMonthDropdownChange = (value: string | number) => {
        const monthNum = Number(value);
        dateRangeSelector.setSelectedMonth(String(monthNum));
        if (dateRangeSelector.selectedMonthYear) {
            applyYearMonth(Number(dateRangeSelector.selectedMonthYear), monthNum);
        }
    };

    const formattedToday = formatDate(startDate)

    const handleRouteClick = (id: string | number) => {
        navigate(URL_MAPPING.MAPVIEW, {
            state: { id, selectDate: formattedToday },
        });
    };

    useEffect(() => {
        const data: any = {
            start_date: formatCurrentStartDate(new Date(startDate)),
            end_date: formatCurrentEndDate(new Date(endDate)),
        };

        if (searchQuery) {
            data["search"] = searchQuery;
        }

        getPayload(data);

        const params = {
            page: currentPage,
            size: employeesPerPage,
        };
        getEmployeesData(data, params);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentPage]);

    useEffect(() => {
        const data: any = {};

        if (selectedRegion.length > 0) {
            data["regions"] = selectedRegion;
        }
        if (selectedSalesOffice.length > 0) {
            data["sales_office_ids"] = selectedSalesOffice;
        }
        if (selectedEmpId.length > 0) {
            data["subordinate_ids"] = selectedEmpId;
        }
        if (territoryId.length > 0) {
            data["territory_ids"] = territoryId;
        }
        if (routeId.length > 0) {
            data["route_ids"] = routeId;
        }
        data["endpoint"] = "visit-summary";
        data["start_date"] = formatCurrentStartDate(new Date(startDate));
        data["end_date"] = formatCurrentEndDate(new Date(endDate));
        data["positions"] =[]

        getGlobalFilters(data);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleFiltersUpdate = () => {
        const data: any = {};

        if (selectedRegion.length > 0) {
            data["regions"] = selectedRegion;
        }
        if (selectedSalesOffice.length > 0) {
            data["sales_office_ids"] = selectedSalesOffice;
        }
        if (selectedEmpId.length > 0) {
            data["subordinate_ids"] = selectedEmpId;
        }
        if (territoryId.length > 0) {
            data["territory_ids"] = territoryId;
        }
        if (routeId.length > 0) {
            data["route_ids"] = routeId;
        }
        data["endpoint"] = "visit-summary";
        data["start_date"] = formatCurrentStartDate(new Date(startDate));
        data["end_date"] = formatCurrentEndDate(new Date(endDate));
        data["positions"] =[]
        getGlobalFilters(data);
    };

    const getPayload = (data: any) => {
        if (selectedEmpStatus.length > 0) {
            data["status"] = selectedEmpStatus;
        }
        if (
            selectedOrderType.length > 0 &&
            selectedOrderType[0] !== "ALL"
        ) {
            data["order_type"] = selectedOrderType[0];
        }

        if (channelId.length > 0) {
            data["channel_ids"] = channelId;
        }
        if (selectedRegion.length > 0) {
            data["regions"] = selectedRegion;
        }
        if (routeId.length > 0) {
            data["route_ids"] = routeId;
        }
        if (selectedSalesOffice.length > 0) {
            data["sales_office_ids"] = selectedSalesOffice;
        }
        if (selectedEmpId.length > 0) {
            data["subordinate_ids"] = selectedEmpId;
        }
        if (territoryId.length > 0) {
            data["territory_ids"] = territoryId;
        }
        if (userType) {
            data["user_type"] = userType;
        }

    };

    const handleApply = (sort: string) => {
        setCurrentPage(1);
        const data: any = {
            start_date: formatCurrentStartDate(new Date(startDate)),
            end_date: formatCurrentEndDate(new Date(endDate)),
        };
        if (searchQuery) {
            data["search"] = searchQuery;
        }
        getPayload(data);
        if (sort) {
            data["sort_by"] = sort;
        }
        const params = {
            page: 1,
            size: employeesPerPage,
        };

        getEmployeesData(data, params);
        handleClose();
    };

    const checkTimeFrame = (start: any, end: any) => {
        if (start === formatDate(new Date()) && end === formatDate(new Date())) {
            setSelectTimeFrame("Today");
        } else if (
            start === formatDate(new Date().setDate(new Date().getDate() - 1)) &&
            end === formatDate(new Date().setDate(new Date().getDate() - 1))
        ) {
            setSelectTimeFrame("Yesterday");
        } else if (
            start === formatDate(new Date().setDate(1)) &&
            end === formatDate(new Date())
        ) {
            setSelectTimeFrame("Month till date");
        } else {
            setSelectTimeFrame("");
        }
    };

    useEffect(() => {
        setSelectedSalesOffice("");
        setTerritoryId("");
        setRouteId("");
        setSelectedEmpId("");
    }, [selectedRegion]);

    useEffect(() => {
        setTerritoryId("");
        setRouteId("");
        setSelectedEmpId("");
    }, [selectedSalesOffice]);

    useEffect(() => {
        setRouteId("");
        setChannelId("");
        setSelectedEmpId("");
    }, [territoryId]);

    useEffect(() => {
        if (selectedEmpId) {
            globalFilters?.employees?.map((value: any) => {
                if (selectedEmpId === value.id) {
                    setUserType(value.position);
                }
            });
        } else {
            setUserType("");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedEmpId]);

    const handleSetImage = (url: any, type: string) => {
        setImgUrl(url);
        setViewImg(true);
        setImgType(type);
    };

    const handleSyncOrder = async (orderId: string | number) => {
        setSyncingOrderId(orderId);
        try {
            await syncB2BOrderOnSAP(orderId);
            toast.success("Sync started for order " + orderId);
            // Optionally, refresh the data after sync
            const data: any = {
                start_date: formatCurrentStartDate(new Date(startDate)),
                end_date: formatCurrentEndDate(new Date(endDate)),
            };
            if (searchQuery) {
                data["search"] = searchQuery;
            }
            getPayload(data);
            const params = {
                page: currentPage,
                size: employeesPerPage,
            };
            await getEmployeesData(data, params);
        } catch (error) {
            toast.error("Sync failed for order " + orderId);
        } finally {
            setSyncingOrderId(null);
        }
    };

    return (
        <DashboardPage>
            <ToastContainer />
            <div className="bg-gray-50  sm:pl-0 pr-4 ">
                {/* Report Title */}
                <div className="bg-white p-4 border-b-2">
                    <h1 className="text-l font-bold text-gray-800">
                        {t("b2breport.title")}
                    </h1>
                </div>
                <div className="hidden mb-2 sm:flex flex-col sm:flex-row justify-between items-center bg-white p-2 border-b-2">
                    <div className="w-full sm:w-auto mb-4 sm:mb-0 pl-6">
                        <PaginationComponent
                            totalCount={employees?.total}
                            itemsPerPage={employees?.size}
                            currentPage={currentPage}
                            setCurrentPage={setCurrentPage}
                        />
                    </div>

                    <div className="flex flex-col sm:flex-row items-center w-full sm:w-auto space-y-4 sm:space-y-0 sm:space-x-4">
                        <div className="relative w-full sm:w-auto">
                            <div className="absolute inset-y-0 left-0 flex items-center pl-3">
                                {/* Add your search icon here */}
                                <img src={Search} alt="search" />
                            </div>
                            <input
                                type="text"
                                value={searchQuery}
                                onChange={(e) => handleChange(e.target.value)}
                                placeholder={t("planogram.searchPlaceholder")}
                                className="w-full sm:w-auto pl-10 pr-4 py-2 text-16 border rounded text-gray-600"
                                style={{ borderColor: "#e0e0e0" }}
                            />
                        </div>

                        {/* Buttons group for desktop */}
                        <div className="hidden sm:flex space-x-4 items-center">
                            {isDropdownOpen && (
                                <ul className="absolute z-50 right-30 top-10 w-48 bg-white border border-gray-300 rounded shadow-lg">
                                    <li
                                        className={`px-4 py-2 hover:bg-gray-100 cursor-pointer ${sortType === "ASC" && "bg-lightgrey"
                                            }`}
                                        onClick={() => handleSortFillter("ASC")}
                                    >
                                        {t("planogram.ascending")}
                                    </li>
                                    <li
                                        className={`px-4 py-2 hover:bg-gray-100 cursor-pointer  ${sortType === "DESC" && "bg-lightgrey"
                                            }`}
                                        onClick={() => handleSortFillter("DESC")}
                                    >
                                        {t("planogram.descending")}
                                    </li>
                                </ul>
                            )}
                                                        <button
                                onClick={handleExport}
                                className={`flex items-center gap-2 px-4 py-2 text-13 font-medium border rounded transition-all ${loading ? "opacity-50 cursor-not-allowed" : ""
                                    }`}
                                disabled={loading}
                            >
                                {loading ? (
                                    <span className="flex items-center gap-2">
                                        <span className="loader w-4 h-4 border-2 border-t-2 border-gray-300 rounded-full animate-spin"></span>
                                        {t("masterList.exporting")}
                                    </span>
                                ) : (
                                    <>
                                        {t("masterList.export")}
                                        <img
                                            src={Export}
                                            alt={t("masterList.export")}
                                            className="w-4 h-4 "
                                        />
                                    </>
                                )}
                            </button>
                            <button
                                onClick={handleFilterClick}
                                className="flex items-center gap-2 px-4 py-2 text-13 font-normal rounded transition-all"
                            >
                                <img
                                    src={Filter}
                                    alt={t("planogram.filter")}
                                    className="w-4 h-4 mr-2"
                                />
                                {t("planogram.filter")}
                            </button>


                        </div>
                    </div>
                </div>
                <div className="sm:hidden flex justify-between items-center p-2 border-b-2 bg-white">
                    <div className="flex-grow">
                        <input
                            type="text"
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            placeholder={t("planogram.searchPlaceholder")}
                            className="w-full px-4 py-2 text-13 border rounded text-gray-600"
                            style={{ borderColor: "#e0e0e0" }}
                        />
                    </div>

                    {/* Hamburger menu for Sort, Filter, Export */}
                    <div className="flex items-center space-x-2">
                        <button
                            onClick={handleExport}
                            className={`flex items-center gap-2 px-4 py-2 text-13 font-medium border rounded transition-all ${loading ? "opacity-50 cursor-not-allowed" : ""
                                }`}
                            disabled={loading}
                        >
                            {loading ? (
                                <span className="flex items-center gap-2">
                                    <span className="loader w-4 h-4 border-2 border-t-2 border-gray-300 rounded-full animate-spin"></span>
                                    {t("masterList.exporting")}
                                </span>
                            ) : (
                                <>
                                    {t("masterList.export")}
                                    <img
                                        src={Export}
                                        alt={t("masterList.export")}
                                        className="w-4 h-4 "
                                    />
                                </>
                            )}
                        </button>

                        <button
                            className="px-2 py-2 text-gray-600 rounded transition-all"
                            onClick={() => setOpen(!open)}
                        >
                            <svg
                                className="w-6 h-6"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    d="M4 6h16M4 12h16m-7 6h7"
                                ></path>
                            </svg>
                        </button>
                    </div>
                </div>
                {open && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-end sm:items-start items-center z-50">
                        <div className="relative bg-white shadow-lg w-full max-w-md h-full">
                            <div className="absolute z-30 top-[50%] left-[45%]">
                                {loadingFilter && <Loader />}
                            </div>
                            <div className="flex justify-between p-6 border-b-2">
                                <div className="text-16 font-bold">
                                    {t("visitreports.filters.title")}
                                </div>
                                <div>
                                    <img
                                        className="cursor-pointer"
                                        onClick={() => setOpen(false)}
                                        src={Close}
                                        alt=""
                                    />
                                </div>
                            </div>
                            <div className="flex flex-col justify-between h-[calc(100vh-100px)] px-12 pt-6 overflow-y-auto scrollbar scrollbar-thin">
                                <div className="flex flex-col gap-[30px]">
                                    <div className="flex gap-4">
                                        <div className="w-1/2">
                                            <DropdownMulti
                                                label={t("visitreports.filters.region")}
                                                options={globalFilters?.regions.map((sales: any) => ({
                                                    value: sales,
                                                    label: sales,
                                                }))}
                                                selectedValues={selectedRegion}
                                                onClose={handleFiltersUpdate}
                                                onChange={setRegion}
                                                placeholder={t("visitreports.filters.selectRegion")}
                                            />
                                        </div>
                                        <div className="w-1/2">
                                            <DropdownMulti
                                                label={t("visitreports.filters.salesOffice")}
                                                options={
                                                    globalFilters?.sales_offices.map((sales: any) => ({
                                                        value: sales.id,
                                                        label: sales.name,
                                                    })) || []
                                                }
                                                selectedValues={selectedSalesOffice}
                                                onClose={handleFiltersUpdate}
                                                onChange={setSelectedSalesOffice}
                                                disabled={selectedRegion.length === 0 || loadingFilter}
                                                placeholder={t(
                                                    "visitreports.filters.selectSalesOffice"
                                                )}
                                            />
                                        </div>
                                    </div>

                                    <div className="flex gap-4">
                                                                                <div className="w-1/2">
                                            <Dropdown
                                                label="Status"
                                                options={statusOptions}
                                                selectedValue={selectedEmpStatus[0] || ""}
                                                onChange={(value) =>
                                                    setSelectedEmpStauts(
                                                        value ? [String(value)] : []
                                                    )
                                                }
     
                                                placeholder="Select Status"
                                            />
                                        </div> 

                                        <div className="w-1/2">
                                            <DropdownMulti
                                                label={t("visitreports.filters.channelID")}
                                                options={
                                                    globalFilters?.channels?.map((emp: any) => ({
                                                        value: emp.id,
                                                        label: emp.name,
                                                    })) || []
                                                }
                                                selectedValues={channelId}
                                                onClose={handleFiltersUpdate}
                                                onChange={setChannelId}
                                                disabled={selectedRegion.length === 0 || loadingFilter}
                                                placeholder={t("visitreports.filters.selectChannelID")}
                                            />
                                        </div>
                                    </div>
                                    <div className="flex gap-4">
                                        <div className="w-1/2">
                                            <Dropdown
                                                label="Order Type"
                                                options={orderTypeOptions}
                                                selectedValue={selectedOrderType[0] || ""}
                                                onChange={(value) =>
                                                    setSelectedOrderType(
                                                        value ? [String(value)] : []
                                                    )
                                                }
                                                placeholder="Select order type"
                                            />
                                        </div>
                                    </div>
                                    {/* <div>
                                        <div className="w-full">
                                            <DropdownMulti
                                                label={t("visitreports.filters.routeID")}
                                                options={
                                                    globalFilters?.routes?.map((emp: any) => ({
                                                        value: `${emp.route_id}`,
                                                        label: emp.route_identifier,
                                                    })) || []
                                                }
                                                selectedValues={routeId}
                                                onClose={handleFiltersUpdate}
                                                onChange={setRouteId}
                                                disabled={selectedRegion.length === 0 || loadingFilter}
                                                placeholder={t("visitreports.filters.selectRouteID")}
                                            />
                                        </div>
                                    </div> */}
                                    <div className="flex gap-4">
                                        {/* <div className="w-full">
                                            <DropdownMulti
                                                label={t("ActivityReport.employeeName")}
                                                options={
                                                    globalFilters?.employees.map((emp: any) => ({
                                                        value: emp.id,
                                                        label: emp.name_eng,
                                                    })) || []
                                                }
                                                selectedValues={selectedEmpId}
                                                onClose={handleFiltersUpdate}
                                                onChange={setSelectedEmpId}
                                                disabled={selectedRegion.length === 0 || loadingFilter}
                                                placeholder={t("ActivityReport.employeeName")}
                                                searchable={true}
                                            />
                                        </div> */}
                                        {/* <div className="w-1/2">
                                            <Dropdown
                                                label={t("visitreports.filters.userType")}
                                                options={
                                                    globalFilters?.user_types.map((emp: any) => ({
                                                        value: emp,
                                                        label: emp,
                                                    })) || []
                                                }
                                                selectedValue={userType}
                                                onChange={setUserType}
                                                disabled={selectedRegion.length === 0 || loadingFilter}
                                                placeholder={t("visitreports.filters.selectUserType")}
                                            />
                                        </div> */}
                                    </div>

                                    {/* Year / Month dropdowns */}
                                    <div className="date-range-picker space-y-2">
                                        <div className="flex gap-4 justify-between w-full">
                                            <div className="w-full">
                                                <label className="block text-10 text-gray-700 mb-1">Year</label>
                                                <Dropdown
                                                    label=""
                                                    options={dateRangeSelector.getMonthYearOptions()}
                                                    selectedValue={dateRangeSelector.selectedMonthYear}
                                                    onChange={handleMonthYearDropdownChange}
                                                    placeholder="Select Year"
                                                />
                                            </div>
                                            <div className="w-full">
                                                <label className="block text-10 text-gray-700 mb-1">Month</label>
                                                <Dropdown
                                                    label=""
                                                    options={dateRangeSelector.getAvailableMonths()}
                                                    selectedValue={dateRangeSelector.selectedMonth ? Number(dateRangeSelector.selectedMonth) : ""}
                                                    onChange={handleMonthDropdownChange}
                                                    placeholder="Select Month"
                                                />
                                            </div>
                                        </div>
                                        <div className="flex gap-4 justify-between w-full">
                                            <div className="w-full">
                                                <label className="block text-10 text-gray-700 mb-1">
                                                    {t("visitreports.filters.startDate")}:
                                                </label>
                                                <input
                                                    type="date"
                                                    className={`rounded p-2 border-2 border-gray-400 w-full ${dateMode === "month" ? "bg-gray-100 text-gray-400 cursor-not-allowed opacity-70" : ""}`}
                                                    value={startDate}
                                                    onChange={handleStartDateChange}
                                                    onKeyDown={(e) => e.preventDefault()}
                                                    max={new Date(endDate).toISOString().split("T")[0]}
                                                    min={(() => {
                                                      const end = new Date(endDate);
                                                      const minDate = new Date(end);
                                                      minDate.setDate(end.getDate() - 30);
                                                      return minDate > new Date(0) ? minDate.toISOString().split("T")[0] : '1970-01-01';
                                                    })()}
                                                    disabled={dateMode === "month"}
                                                />
                                            </div>
                                            <div className="w-full">
                                                <label className="block text-10 text-gray-700 mb-1">
                                                    {t("visitreports.filters.endDate")}:
                                                </label>
                                                <input
                                                    type="date"
                                                    className={`rounded p-2 border-2 border-gray-400 w-full ${dateMode === "month" ? "bg-gray-100 text-gray-400 cursor-not-allowed opacity-70" : ""}`}
                                                    max={new Date().toISOString().split("T")[0]}
                                                    min={new Date(startDate).toISOString().split("T")[0]}
                                                    value={endDate}
                                                    onChange={handleEndDateChange}
                                                    onKeyDown={(e) => e.preventDefault()}
                                                    disabled={dateMode === "month"}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <TimeFrameSelector
                                            customClass={"w-full border border-gray-300 rounded p-2"}
                                            setSelectTimeFrame={(tf) => {
                                                setDateMode("picker");
                                                dateRangeSelector.setSelectedMonthYear("");
                                                dateRangeSelector.setSelectedMonth("");
                                                setSelectTimeFrame(tf);
                                            }}
                                            timeFrame={timeFrame}
                                            setStartDate={setStartDate}
                                            setEndDate={setEndDate}
                                        />
                                    </div>
                                </div>

                                {/* Action Buttons */}
                                <div className="flex justify-between mt-4">
                                    <Button
                                        onClick={handleClearFilters}
                                        label={t("visitreports.filters.clearFilter")}
                                        type="grey"
                                    />
                                    <Button
                                        onClick={() => handleApply(sortType)}
                                        label={t("visitreports.filters.applyFilter")}
                                        type="purple"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                <div className="h-[calc(100vh-200px)] md:h-[calc(100vh-125px)] overflow-auto page-container p-2 pt-0 scrollbar scrollbar-thin">
                    <table className="min-w-full bg-white border border-black-200 table-auto border-separate border-spacing-0">
                        <thead className="bg-gray-200 sticky top-[0px] z-20">
                            <tr>
                                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                                    {t("Order ID")}
                                </th>
                                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                                    {t("SAP PO")}
                                </th>
                                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                                    {t("Customer ID")}
                                </th>
                                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                                    {t("Customer Name")}
                                </th>
                                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                                    {t("PO Carton Qty")}
                                </th>
                                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                                    {t("200ml")}
                                </th>
                                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                                    {t("330ml")}
                                </th>
                                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                                    {t("500ml")}
                                </th>
                                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                                    {t("600ml")}
                                </th>
                                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                                    {t("1.5L")}
                                </th>
                                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                                    {t("12L")}
                                </th>
                                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                                    {t("Glass")}
                                </th>
                                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                                    {t("Other")}
                                </th>
                                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                                    {t("Creation Date")}
                                </th>
                                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                                    {t("Creation Time")}
                                </th>
                                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                                    {t("Status")}
                                </th>
                                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                                    {t("Status on SAP")}
                                </th>
                                {/* <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                                    {t("Created By")}
                                </th> */}
                                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                                    {t("Order Value")}
                                </th>
                                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                                    {t("Order Type")}
                                </th>
                                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                                    {t("Sales Office")}
                                </th>
                                {/* <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                                    {t("Payment Reference")}
                                </th> */}
                                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                                    {t("Payment Method")}
                                </th>
                                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                                    {t("Paid amount")}
                                </th>
                                                                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                                    {t("HyperPay Transaction ID")}
                                </th>
                                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                                    {t("Wallet Paid Amount")}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {employees?.items?.length > 0 &&
                                !loading &&
                                employees.items.map((item: any, index: number) => (
                                    <tr key={index} className="text-16 hover:bg-gray-50">
                                        <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                                            {item.order_id || "-"}
                                        </td>
                                        <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                                            {item.sap_po || "-"}
                                        </td>
                                        <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                                            {item.customer_id || "-"}
                                        </td>
                                        <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                                            {item.customer_name || "-"}
                                        </td>
                                        <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                                            {item.po_carton_qty || "-"}
                                        </td>
                                        <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                                            {item.ml_200 || "-"}
                                        </td>
                                        <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                                            {item.ml_330 || "-"}
                                        </td>
                                        <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                                            {item.ml_500 || "-"}
                                        </td>
                                        <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                                            {item.ml_600 || "-"}
                                        </td>
                                        <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                                            {item.ml_1_5ltr || "-"}
                                        </td>
                                        <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                                            {item.ml_12ltr || "-"}
                                        </td>
                                        <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                                            {item.glass || "-"}
                                        </td>
                                        <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                                            {item.other || "-"}
                                        </td>
                                        <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                                            {item.creation_date || "-"}
                                        </td>
                                        <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                                            {item.creation_time ? moment
                          .utc(item.creation_time, "HH:mm:ss.SSSSSS")
                          .local()
                          .format("hh:mm A")
                        : "-"}
                                        </td>
                                        <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                                        {(() => {
                                            // If status is confirmed but SAP status is pending, show pending
                                            if (item.status === "CONFIRMED" && item.confirmed_on_sap === false) {
                                                return "PENDING";
                                            }
                                            // If SAP status is SUCCESS and status is not delivered, show confirmed
                                            if (item.confirmed_on_sap === true && item.status !== "DELIVERED") {
                                                return "CONFIRMED";
                                            }
                                            // Otherwise, show original status
                                            return item.status || "-";
                                        })()}
                                        </td>
                                        <td className="px-4 py-3 border text-black-600 whitespace-nowrap" style={{ minWidth: 120 }}>
  {item.confirmed_on_sap === true ? (
    "SUCCESS"
  ) : (
    <span style={{ display: "flex", alignItems: "center", gap: 8, justifyContent: 'space-between', width: '100%' }}>
      <span style={{ flexShrink: 0 }}>PENDING</span>
      <button
        style={{ marginLeft: 4, background: "none", border: "none", cursor: "pointer", padding: 0, flexShrink: 0 }}
        onClick={() => handleSyncOrder(item.order_id)}
        disabled={syncingOrderId === item.order_id}
        title="Sync on SAP"
      >
        {syncingOrderId === item.order_id ? (
          <img src={SyncIcon} alt="Syncing..." style={{ width: 18, height: 18, animation: "spin 1s linear infinite" }} />
        ) : (
          <img src={SyncIcon} alt="Sync" style={{ width: 18, height: 18 }} />
        )}
      </button>
    </span>
  )}
</td>
                                        {/* <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                                            {item.created_by || "-"}
                                        </td> */}
                                        <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                                            {formatNumber(item.order_value) || "-"}
                                        </td>
                                        <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                                            {item.order_type || "-"}
                                        </td>
                                        <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                                            {item.sales_office_distr || "-"}
                                        </td>

                                        <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                                            {item.payment_method || "-"}
                                        </td>
                                        <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                                            {item.paid_online_amount || "-"}
                                        </td>
                                                                 <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                                            {item.hyperpay_payment_id || "-"}
                                        </td>
                                        <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                                            {formatNumber(item.wallet_paid_amount) || "-"}
                                        </td>
                                    </tr>
                                ))}
                        </tbody>
                    </table>
                    {employees?.items?.length === 0 && !loading && (
                        <>
                            <div className="px-4 py-3 border text-center text-black-600 w-full flex items-center justify-center">
                                {t("planogram.noresultsfound")}
                            </div>
                        </>
                    )}
                    {loading && <Loader />}
                </div>
                <div className="sm:hidden bg-white p-2 border-t-2 mt-auto">
                    <PaginationComponent
                        totalCount={employees?.total}
                        itemsPerPage={employees?.size}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                    />
                </div>
            </div>
        </DashboardPage>
    );
};

export default B2BReport;
